import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Avatar } from '../../components/avatar/avatar.component';
import { Heading } from '../../components/heading/heading.component';
import { IconButton } from '../../components/icon-button/icon-button.component';
import { Text } from '../../components/text/text.component';
import { BackIcon } from '../../icon/icons/back';
import { useContentPanel } from './content-context';
import { ContentPanelHeaderBar } from './content-header-bar';

const contentPanelHeaderDivStyle1 = css`
  display: grid;
  gap: ${theme.spacing(1)};
  grid-auto-flow: column;
  align-items: center;
`;

const contentPanelHeaderDivStyle2 = css`
  width: 100%;
`;

const contentPanelHeaderDivStyle3 = css`
  margin-left: ${theme.spacing(0.5)};
`;

const contentPanelHeaderTextStyle4 = css`
  max-width: 700px;
`;

const contentPanelHeaderDivStyle5 = css`
  padding-right: 1em;
  padding-left: 1em;
`;

type Props = {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  showAvatar?: boolean;
  src?: string;
  children?: React.ReactNode;
  level?: 1 | 2 | 3;
  className?: string;
};

export const ContentPanelHeader = ({
  title,
  level = 1,
  children,
  subtitle,
  showAvatar,
  src,
  action,
  ...rest
}: Props) => {
  const panel = useContentPanel();
  const shouldShowBack = panel?.hasBack;

  return (
    <ContentPanelHeaderBar {...rest}>
      <div className={cx(contentPanelHeaderDivStyle1, !!children && contentPanelHeaderDivStyle2)}>
        {shouldShowBack && (
          <IconButton label='Go Back' onClick={() => panel.onBackClick?.()}>
            <BackIcon />
          </IconButton>
        )}
        {showAvatar && <Avatar name={title} src={src} size='large' />}
        <div className={cx(showAvatar && contentPanelHeaderDivStyle3)}>
          {children ? (
            children
          ) : (
            <>
              <Heading level={level}>{title}</Heading>
              {!!subtitle && (
                <Text color='light' className={contentPanelHeaderTextStyle4}>
                  {subtitle}
                </Text>
              )}
            </>
          )}
        </div>
      </div>
      {action && <div className={contentPanelHeaderDivStyle5}>{action}</div>}
    </ContentPanelHeaderBar>
  );
};
